<template>
  <div class="dialog-box" :style="{display: message.isOpened ? 'none' : 'block'}">
    <unit-image
      class="unit-image"
      v-if="message.unit"
      :unitType="message.unit.template.type"
      :season="'default'"
    />
    <span class="dialog-box-label">{{message.title}}</span>
  </div>
</template>

<script>
import UnitImage from '@/components/game/UnitImage';

export default {
  name: 'DialogBox',
  props: ['message'],
  components: {
    'unit-image': UnitImage,
  },
  created() {
    this.$store.dispatch('readNotification', this.message.id);
  },
};
</script>

<style scoped lang="scss">
.dialog-box {
  color: #333;
  text-align: left;
  background: #fff;
  box-shadow: 0 2px 10px 0 rgba(#000, 0.1);
  padding: 0.25em 1em;
  margin-bottom: 0.25em;
  border-radius: 3px;

  &:after {
    content: '';
    clear: both;
    display: block;
  }

  .unit-image {
    display: block;
    margin: 0;
    width: 2rem;
    height: 2rem;
    float: left;
    margin-right: 0.5em;
  }

  .dialog-box-label {
    line-height: 2rem;
    font-size: 0.8rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/game/DialogBox.vue